// extracted by mini-css-extract-plugin
export var collapsedSummary = "_iq-0";